import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import ConfirmDeleteSustainability from "./confirmDeleteSustainabilityData"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

enum DeletingSustainability {
  Confirm,
  Error,
}

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const DeleteSustainabilityModal = ({
  onClose,
  parent2Callback,
  sustainabilityId,
}: {
  onClose: () => void
  parent2Callback: () => void
  sustainabilityId: string
}) => {
  const [step, setStep] = useState<DeletingSustainability>(
    DeletingSustainability.Confirm
  )

  const [errordata, setErrorData] = useState<{
    error: string
  }>({
    error: "",
  })

  return (
    <Overlay onClick={() => onClose()}>
      <ModalCard onClose={onClose}>
        {step === DeletingSustainability.Confirm && (
          <ConfirmDeleteSustainability
            sustainabilityId={sustainabilityId}
            onCancel={() => onClose()}
            onError={(error) => {
              setErrorData((prev) => ({ ...prev, error }))
              setStep(DeletingSustainability.Error)
            }}
            onSuccess={() => onClose()}
            parentCallback={() => parent2Callback()}
          />
        )}
        {step === DeletingSustainability.Error &&
          `API Error: ${errordata.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default DeleteSustainabilityModal
